import { CloudStake } from './cloud';
import { ThirdStake } from './third';
import { useWallet } from '@/hooks/wallet';

import styles from './index.module.scss';

export const Stake = ({ activity }) => {
  const { isThird } = useWallet();

  return (
    <div className={styles.container}>
      {isThird && <ThirdStake activity={activity} />}
      {!isThird && <CloudStake activity={activity} />}
    </div>
  );
};
